module.exports = __webpack_public_path__ + "static/media/french-fries.061bd213.png";